export default __webpack_public_path__ + "static/media/AboutmeHorizontal.40d680f8.PNG";